import request from "@/utils/request";
let serveUrl = 'https://portal-service.pass.lygtc.edu.cn/'
// let serveUrl = 'http://192.168.2.82:20001/'
export function getWorkInfo() {
  return request({
    url: `${serveUrl}portalCenter/v2/personalData/getWeekData?pageNo=1&pageSize=2000&startDate=&endDate= `,
    method: "get",
	  headerType: "open"
  });
}

export function getDataWorkList(data) {
  return request({
    url: `${serveUrl}portalCenter/v2/personalData/getWeekData?pageNo=1&pageSize=2000&startDate=${data.startDate}&endDate=${data.endDate}`,
    method: "get",
	  headerType: "open"
  });
}

// 分页获取数据
export function getPaganationWorkList(data) {
  return request({
    url: `${serveUrl}portalCenter/v2/personalData/getWeekData?pageNo=${data.pageNo}&pageSize=${data.pageSize}&startDate=${data.startDate}&endDate=${data.endDate}`,
    method: "get",
	  headerType: "open"
  });
}

export function getSalaryList(data) {
  return request({
    url: `${serveUrl}portalCenter/v2/personalData/getSalaryDataInfo?pageNo=${data.pageNo}&pageSize=${data.pageSize}&schoolYear=&userName=${data.userName}`,
    method: "get",
	  headerType: "open"
  });
}

// 根据日期查询
export function getDateSalaryList(data) {
  return request({
    url: `${serveUrl}portalCenter/v2/personalData/getSalaryDataInfo?pageNo=1&pageSize=1&schoolYear=${data.schoolYear}&userName=${data.userName}`,
    method: "get",
	  headerType: "open"
  });
}

export function getBookList(data) {
  return request({
    url: `${serveUrl}portalCenter/v2/personalData/getMyBooksInfo?userName=${data.userName}`,
    method: "get",
	  headerType: "open",
    headers: {
      "Content-Type": "application/json;charset=UTF-8"
    },
  });
}